<template>
  <div
    class="yxtbiz-ote-ai-ques"
    :class="{
      'yxtbiz-ote-ai-ques--error': quesEdited.error && quesBody.showError,
      'yxtbiz-ote-ai-ques--batch' : batching
    }"
  >
    <!-- 编辑 -->
    <ques-detail
      :quesBody.sync="quesEditing"
      @save="saveQues"
      @cancel="editCancel"
      v-if="editing"
      :libId="libId"
      :create="create"
      :libName="libName"
      :examId="examId"
    />
    <!-- 预览 -->
    <template v-else>
      <div @click="editQues()" class="hand">
        <!-- 题干 -->
        <div class="flex">
          <div class="lh22">
            <span v-if="index" class="color-gray-10 yxt-weight-5"
              >{{ index }}.
            </span>
            <span
              v-if="quesEdited.error === 1"
              class="yxtbiz-ote-ai-ques__error-info"
            >
              【{{ quesEdited.errorMsg }}】
            </span>
            <span
              class="color-gray-10 yxt-weight-5"
              v-html="cleanStyle(quesEdited.content)"
            ></span>
          </div>

          <span class="yxtbiz-ote-ai-ques__qt">{{
            $t(QUES_TYPE_NAMES[quesEdited.type])
          }}</span>
        </div>
        <!--  选项 -->
        <yxt-row class="mv4">
          <!-- 单选题选项 -->
          <yxt-radio-group
            v-if="quesEdited.type === 0"
            v-model="singleAnswer"
            class="yxtbiz-question-preview__radio-group"
            :direction="'row'"
            :disabled="true"
          >
            <yxt-radio
              v-for="(item, index) in quesEdited.questionItems"
              :key="item.id"
              :value="item.answer"
              class="yxtbiz-question-preview__radio"
              :label="index"
            >
              <div class="flex">
                <span class="yxtbiz-flex-shrink-0"
                  >{{ convertASCIIForNum(index) }}.</span
                >
                <span
                  class="ml4"
                  v-html="cleanStyle(item.itemContent, true)"
                ></span>
              </div>
            </yxt-radio>
          </yxt-radio-group>
          <!-- 多选题选项 -->
          <yxt-checkbox-group
            v-if="quesEdited.type === 1"
            v-model="multiAnswer"
            class="yxtbiz-question-preview__checkbox-group"
            :direction="'row'"
            :disabled="true"
          >
            <yxt-checkbox
              v-for="(item, index) in quesEdited.questionItems"
              :key="item.id"
              class="yxtbiz-question-preview__checkbox"
              :label="index"
            >
              <div class="flex">
                <span class="yxtbiz-flex-shrink-0"
                  >{{ convertASCIIForNum(index) }}.</span
                >
                <span
                  class="ml4"
                  v-html="cleanStyle(item.itemContent, true)"
                ></span>
              </div>
            </yxt-checkbox>
          </yxt-checkbox-group>
          <!-- 判断题选项 -->
          <yxt-radio-group
            v-if="quesEdited.type === 2"
            class="yxtbiz-question-preview__radio-group"
            :direction="'row'"
            :disabled="true"
            :value="quesEdited.judgeAnswer"
          >
            <yxt-radio class="yxtbiz-question-preview__radio" :label="1">
              A.
              {{
                quesEdited.judgeCorrectOptionContent
                  ? quesEdited.judgeCorrectOptionContent
                  : $t('pc_biz_ote_lbl_wright')
              }}
            </yxt-radio>
            <yxt-radio class="yxtbiz-question-preview__radio" :label="0">
              B.
              {{
                quesEdited.judgeWrongOptionContent
                  ? quesEdited.judgeWrongOptionContent
                  : $t('pc_biz_ote_lbl_wrong')
              }}
            </yxt-radio>
          </yxt-radio-group>
          <!-- 填空题项 -->
          <!-- <div v-if="quesEdited.type === 3" class="mt4">
            <yxt-input
              v-for="(item, index) in quesEdited.questionItems"
              :key="index"
              class="mb8"
              :value="item.itemContent"
              disabled
            />
          </div> -->
        </yxt-row>
        <template>
          <!-- 关键词 -->
          <div class="color-gray-9 mb8" v-if="quesEdited.keywords && quesEdited.keywords.length>0">
            <span>{{ $t('pc_biz_ote_keyword') }}：</span
            ><span>{{ quesEdited.keywords.map(k => `${k.name}(${k.rate}%)`).join(';')  }}</span>
          </div>
          <!-- 答案 -->
          <div class="color-gray-9 flex">
            <span class="flex-shrink-0"
              >{{ $t('pc_biz_ote_lbl_itemanswer') }}：</span
            >
            <span
              v-if="quesEdited.error === 2"
              class="yxtbiz-ote-ai-ques__error-info"
            >
              {{ quesEdited.errorMsg }}
            </span>
            <!-- 单选题 -->
            <span v-else-if="quesEdited.type === 0">
              {{ convertASCIIForNum(singleAnswer) }}</span
            >
            <!-- 多选题 -->
            <span v-else-if="quesEdited.type === 1">
              <span v-for="(item, index) in multiAnswer" :key="item"
                >{{ index > 0 ? '、' : '' }}{{ convertASCIIForNum(item) }}</span
              >
            </span>
            <!-- 判断题 -->
            <span v-else-if="quesEdited.type === 2">{{
              quesEdited.judgeAnswer === 0 ? 'B' : 'A'
            }}</span>
            <!-- 填空题 -->
            <span v-else-if="quesEdited.type === 3">
              <template
                v-if="quesEdited.questionItems && quesEdited.questionItems.length"
              >
                <div
                  v-for="(item, index) in quesEdited.questionItems"
                  :key="index"
                >
                  {{ quesEdited.questionItems.length>1 ? (index + 1 + '. '):'' }}{{ item.itemContent
                  }}<span
                    v-if="
                      item.alternativeContents &&
                      item.alternativeContents.length > 0
                    "
                    >;{{ item.alternativeContents.join(';') }}</span
                  >
                </div>
              </template>
              <span v-else>
                <span>{{ $t('pc_biz_ote_lbl_none') }}</span>
              </span>
            </span>
            <!-- 问答题 -->
            <span v-else-if="quesEdited.type === 4">
              <span
                v-html="
                  cleanStyle(quesEdited.answerContent, true) ||
                  $t('pc_biz_ote_lbl_none')
                "
              ></span>
            </span>
          </div>
          <!-- 难度 -->
          <div class="color-gray-9 mt8">
            <span>{{ $t('pc_biz_ote_lbl_queslevel') }}：</span
            ><span>{{ getLevelType(quesEdited.levelType) }}</span>
          </div>
          <!-- 解析 -->
          <div class="color-gray-9 mt8">
            <span>{{ $t('pc_biz_ote_lbl_quesanalyze') }}：</span
            ><span>
              <span
                v-if="quesEdited.explainText"
                v-html="cleanStyle(quesEdited.explainText)"
              ></span>
              <!-- 暂无解析 -->
              <span v-else>{{ $t('pc_biz_ote_lbl_noquesanalysis') }}</span>
            </span>
          </div>
        </template>
        <!--  右上角操作按钮 -->
        <div class="yxtbiz-ote-ai-ques__operations" v-if="!batching" @click.stop="">
          <div class="yxtbiz-ote-ai-icon hand" @click.stop="editQues()">
            <yxt-svg width="16px" height="16px" icon-class="edit"></yxt-svg>
          </div>
          <div class="yxtbiz-ote-ai-icon ml8 hand" @click.stop="deleteQues()">
            <yxt-svg width="16px" height="16px" icon-class="delete"></yxt-svg>
          </div>
        </div>
      </div>
    </template>
    <div class="yxtbiz-ote-ai-ques__batch-check" v-if="batching">
      <yxt-checkbox v-model="quesBody.checked" @change="changeChecked"></yxt-checkbox>
    </div>
  </div>
</template>
<script>
import { cleanStyle, convertASCIIForNum } from '../utils';
import { QUES_LEVEL_NAMES, QUES_TYPE_NAMES } from '../const';
import quesDetail from './quesDetail.vue';

export default {
  name: 'quesViewInfo',
  components: {
    quesDetail
  },
  data() {
    return {
      QUES_TYPE_NAMES,
      quesEdited: null,
      quesEditing: null,
      editing: false // 试题编辑中
    };
  },
  props: {
    quesBody: {
      type: Object,
      default: () => {
        return {checked: false};
      }
    },
    index: {
      type: Number,
      default: 0
    },
    // 有题目编辑中
    otherEditing: {
      type: Boolean,
      default: false
    },
    batching: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
    libId: {
      type: String,
      default: ''
    },
    libName: {
      type: String,
      default: ''
    },
    libType: {
      type: String,
      default: ''
    },
    examId: {
      type: String
    }
  },
  computed: {
    singleAnswer() {
      return (
        this.quesEdited &&
        this.quesEdited.questionItems.findIndex(q => !!q.answer)
      );
    },
    multiAnswer() {
      return (
        this.quesEdited &&
        this.quesEdited.questionItems
          .map((q, index) => {
            if (q.answer) {
              return index;
            }
            return undefined;
          })
          .filter(e => e !== null && e !== undefined)
      );
    }
  },
  watch: {},
  created() {
    this.$set(this.quesBody, 'checked', false);
    this.quesEdited = this.quesBody.quesEdited || this.quesBody;
    if (this.create) {
      this.editQues();
    }
  },
  mounted() {},
  methods: {
    cleanStyle,
    editQues() {
      if (this.batching) {
        this.quesBody.checked = !this.quesBody.checked;
        this.$emit('check');
        return;
      }
      if (this.otherEditing) {
        this.$message({
          showClose: false,
          message: this.$t('pc_biz_ote_msg_confirmquestionediting'), // 请先确认正在编辑的试题
          type: 'warning'
        });
        return false;
      }
      this.editing = !this.editing;
      this.quesEditing = JSON.parse(JSON.stringify(this.quesEdited));

      this.$emit('editStart', this.quesEdited);
    },
    deleteQues() {
      this.$emit('delete', this.quesBody);
    },
    saveQues(ques) {
      this.quesEdited = ques;
      this.editing = !this.editing;

      this.quesEdited.error = 0;
      this.quesEdited.errorMsg = '';
      this.quesBody.edited = true;
      this.quesBody.type = this.quesEdited.type;
      this.quesBody.quesEdited = this.quesEdited;

      this.$emit('edit', this.quesEdited);
    },
    editCancel() {
      this.editing = false;
      this.$emit('editCancel');
    },
    locateQues() {
      this.$emit('locateQues');
    },
    changeChecked() {
      this.$emit('check');
    },
    getLevelType(val) {
      return QUES_LEVEL_NAMES[val] ? this.$t(QUES_LEVEL_NAMES[val]) : '';
    },
    convertASCIIForNum
  }
};
</script>
